// Cursor pagination. Cursor is opaque base64url of a server-signed `(id, ts)`
// tuple — clients must treat it as a black box. Offsets are not supported.
import { Type } from '@sinclair/typebox';
export const PaginationQuerySchema = Type.Object({
    cursor: Type.Optional(Type.String({ minLength: 1, maxLength: 512 })),
    limit: Type.Optional(Type.Integer({ minimum: 1, maximum: 100 })),
}, { $id: 'PaginationQuery', additionalProperties: false });
export function makePageSchema(itemSchema) {
    return Type.Object({
        items: Type.Array(itemSchema),
        nextCursor: Type.Union([Type.String({ minLength: 1, maxLength: 512 }), Type.Null()]),
    }, { additionalProperties: false });
}
//# sourceMappingURL=pagination.js.map